import React, { useEffect, useRef, useState } from 'react';

import {
    Box, Flex, useColorMode
} from "@chakra-ui/react";

import { motion, AnimatePresence } from 'framer-motion';

import bgimg from "../images/home/whale.webp";
import bgvid from "../videos/whale.mov";

import lrLight from "../images/home/lr_day.webp";
import lrDark from "../images/home/lr_night.webp";

import "../css/title.css";

import { SwitchColorModeButton } from "../parts/ToggleColorModeButton";
import { NavMenu } from "../parts/AppMenuButtons";
import { Helmet } from 'react-helmet';

const FrontPage = () => {

    const videoRef = useRef(null);
    const [percentage, setPercentage] = useState(1);
    const { colorMode } = useColorMode();

    useEffect(() => {

        document.title = "Home";

        const handleResize = () => {
            const basePercent = 28.7;
            const { innerWidth: width, innerHeight: height } = window;
            if (width >= height) {
                setPercentage(`${basePercent}vw`);
            } else {
                setPercentage(`${basePercent}vh`);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Box>
            <Helmet>
                <meta name="description" content={"In every color, there's the light."} />
            </Helmet>
            <Flex position="fixed" top="0" left="0" w="100vw" h="100vh" overflow="hidden" justifyContent="center" alignItems="center">
                <Box position="absolute" w={`${percentage}`}>
                    <video autoPlay muted loop playsInline poster={bgimg} ref={videoRef} style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}>
                        <source src={bgvid} type="video/mp4" />
                    </video>
                </Box>
                <AnimatePresence>
                    {colorMode === "light" &&
                        <motion.img src={lrLight} style={{
                            position: "absolute",
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                        }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }} />}
                </AnimatePresence>
                <AnimatePresence>
                    {colorMode === "dark" &&
                        <motion.img src={lrDark} style={{
                            position: "absolute",
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                        }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }} />}
                </AnimatePresence>
            </Flex>
            <Box position="fixed" top="12px" left="12px">
                <NavMenu />
            </Box>
            <Box position="fixed" top="12px" right="12px">
                <SwitchColorModeButton />
            </Box>
        </Box>
    )
};

export default FrontPage;
